import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs, setLoading } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import loginInfo from "../../components/LoginInfo";
import { toggleActivateTemplate } from "../../CroActions";

import { DocumentTemplatesType } from "../../enum";
import { TemplatesDocument } from "../../components/grids/DocumentTemplatesGrid";

class DocumentTemplates extends Component {
  state = {
    selectedType: null,
    loading: true,
  };

  async componentDidMount() {
    const { dispatch } = this.props;

    this.props.breadcrumbs([{ label: "Šablony" }]);

    dispatch(setLoading(true, "Načítání dat..."));
    this.setState({
      selectedType: DocumentTemplatesType[0].id,
      loading: false,
    });
    dispatch(setLoading());
  }

  getActiveType() {
    return DocumentTemplatesType.find((type) => type.id === this.state.selectedType);
  }

  onTypeClick = (type) => () => {
    this.setState({ selectedType: type.id });
  }

  onAdd = ({ type }) => {
    this.props.push(`/administrator/sablony/dokument/form`);
  }

  onOpenDetail = ({ id }) => {
    this.props.push(`/administrator/sablony/dokument/form/${id}`);
  };  
  
  onDeactivateTemplate = async ({ id, type }) => {
    await this.props.dispatch(toggleActivateTemplate(id, false));
    this.reloadGrid();
  }

  onActivateTemplate = async ({ id, type }) => {
    await this.props.dispatch(toggleActivateTemplate(id, true));
    this.reloadGrid();
  }

  reloadGrid = () => {
    const activeType = this.getActiveType();
    this.setState({ selectedType: null });
    this.setState({ selectedType: activeType.id });
  }

  render() {
    const { loading } = this.state;
    if (loading) {
      return <></>;
    }

    const activeType = this.getActiveType();


    const ApiUrl = '/spravce/api/sablony';
    const GridComponent = TemplatesDocument;

    return (
      <div className="documentTemplatesPage">
        <div className="pageTabs pageTabs--templates">
          <div className="pageTabs__scroller">
            {DocumentTemplatesType.map((type) => (
              <button
                key={type.id}
                type="button"
                className={
                  activeType && activeType.id === type.id ? "pageTabs__tab pageTabs__tab--active" : "pageTabs__tab"
                }
                onClick={this.onTypeClick(type)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </div>
        {activeType && (
          <GridComponent
            {...this.props}
            url={ApiUrl}
            query={{ type: activeType.id }}
            gridName={`documentTemplatesGrid_${activeType.id}`}
            adding={true}
            onAdd={this.onAdd}
            onRowClick={this.onOpenDetail}
            onActivateTemplate={this.onActivateTemplate}
            onDeactivateTemplate={this.onDeactivateTemplate}
          />
        )}
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(loginInfo(DocumentTemplates));
